import React, { useState } from "react";
import AllApps from "./AllApps";
import Wallets from "./Wallets";
import "./custom.css";

const Registry = () => {
  const [stepState, setStepState] = useState(0);
  const panel = [<Wallets />, <AllApps />];
  const onChangePanel = (index) => setStepState(index);

  return (
    <div>
      <div className="font-bold text-2xl md:text-4xl mt-6 text-blue-700 md:ml-16 ml-2">
        Connect wallet to get started
      </div>
      <div className="flex px-2 pt-16 mx-2 md:mx-12">
        <div
          className="seemee cursor-pointer py-2 text-lg md:text-2xl font-bold mx-2 md:mx-6 md:mx-16"
          onClick={() => onChangePanel(0)}
        >
          Wallets
        </div>
        <div
          className="seemee cursor-pointer py-2 text-lg font-bold md:text-2xl mx-2 md:mx-6 md:mx-16"
          onClick={() => onChangePanel(1)}
        >
          Apps
        </div>
      </div>
      <div className="account-captions">{panel[stepState]}</div>
    </div>
  );
};

export default Registry;
